import React, { useEffect } from 'react'
import Footer from '../../componets/General/Footer'
import NavBar from '../../componets/General/NavBar'
import '../../style/circulos.css'
const Circulos = () =>{
    useEffect(()=>{
        window.scrollTo(0,0);
    },[])
    return(
        <>
        <NavBar/>
        <div className = "main0 h-100 w-100">
            <div className="main">
                <div className="circle">
                    <div className="dots"></div>
                </div>
            </div>
        </div>
        <Footer/>
        </>
        )
}

export default Circulos